import React, { useEffect, useState } from "react";
import CookieConsent from "react-cookie-consent";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
      const [name, value] = cookie.split("=");
      acc[name] = value;
      return acc;
    }, {});

    if (cookies["okazion_cookie"] === "true") {
      setShowBanner(false);
      loadGoogleTagManager(); // Load GTM if user has already accepted cookies
    } else if (cookies["okazion_cookie"] === "false") {
      setShowBanner(true);
    }
  }, []);

  const loadGoogleTagManager = () => {
    if (window.gtmLoaded) return; // Prevent duplicate loading
    window.gtmLoaded = true;

    // Initialize dataLayer if not already defined
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    // Load Google Analytics script
    const gtmScript = document.createElement("script");
    gtmScript.async = true;
    gtmScript.src = "https://www.googletagmanager.com/gtag/js?id=G-96377LJ4NE";
    document.head.appendChild(gtmScript);

    gtmScript.onload = () => {
      gtag("js", new Date());
      gtag("config", "G-96377LJ4NE");

      gtag("consent", "update", {
        ad_user_data: "granted",
        ad_personalization: "granted",
        ad_storage: "granted",
        analytics_storage: "granted",
      });
    };
  };

  return (
    showBanner && (
      <CookieConsent
        location="bottom"
        buttonText="Prano"
        declineButtonText="Refuzo"
        enableDeclineButton
        cookieName="okazion_cookie"
        style={{ background: "#fafafa", color: "#52682f" }}
        buttonStyle={{
          background: "#52682f",
          color: "#fafafa",
          fontSize: "13px",
          borderRadius: "5px",
          padding: "8px 30px",
        }}
        declineButtonStyle={{
          background: "#f44336",
          color: "#ffffff",
          fontSize: "13px",
          borderRadius: "5px",
          padding: "8px 30px",
        }}
        expires={150}
        onAccept={() => {
          document.cookie =
            "okazion_cookie=true; path=/; max-age=" + 150 * 24 * 60 * 60;
          console.log("Cookies accepted");
          setShowBanner(false);
          loadGoogleTagManager();
        }}
        onDecline={() => {
          document.cookie =
            "okazion_cookie=false; path=/; max-age=" + 150 * 24 * 60 * 60;
          console.log("Cookies declined");
          window.location.href = "https://www.google.com";
        }}
      >
        Kjo faqe interneti përdor cookie për të përmirësuar përvojën e
        përdoruesit. Duke klikuar "Pranoni", ju pranoni përdorimin tonë të
        cookies.
      </CookieConsent>
    )
  );
};

export default CookieBanner;